import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRealTimeMail } from "../../services/mailboxRealTimeService";
const initialState = {
  isError: false,
  isLoading: false,
  data: [],
  message: "",
  errors: [],
};
const getErrorMessage = (error) => {
  return (
    error?.response?.data?.error ||
    (error?.response?.data?.debugInfo && [error?.response?.data?.debugInfo]) ||
    error?.response?.data?.message ||
    error?.response?.data ||
    error.toString()
  );
};
// Get Mails
export const get_realtime_mail = createAsyncThunk(
  "get_realtime_mail",
  async (data, thunkAPI) => {
    try {
      return await getRealTimeMail(data);
    } catch (error) {
      const message = getErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const mailboxRealTimeSlice = createSlice({
  name: "getRealtimemails",
  initialState,
  reducers: {
    mailBoxReset: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.message = "";
      state.data = [];
      state.errors = [];
    },
    setTaskEmail: (state, action) => {
      state.task_email = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(get_realtime_mail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(get_realtime_mail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
      })
      .addCase(get_realtime_mail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.data = [];
      });
  },
});

export const { mailBoxReset, setTaskEmail } = mailboxRealTimeSlice.actions;
export default mailboxRealTimeSlice.reducer;
